import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';

@Component({
  selector: 'app-navigationmenu',
  templateUrl: './navigationmenu.component.html',
  styleUrls: ['./navigationmenu.component.css']
})
export class NavigationmenuComponent implements OnInit {
  
  userBO: any = {};
  userrolerightsColl: any = [];
  userView: any = {};
companyType:string="";
 
isallowance: boolean = false;
isbonustype: boolean = false;
isdeduction: boolean = false;
isexpensetype: boolean = false;
isexpensepolicy: boolean = false;
isloantype: boolean = false;
ispaymode: boolean = false;
ispaytype: boolean = false;
istranspaymode: boolean = false;
isfinetype: boolean = false;
ispayrollgrp: boolean = false;
isreimbursetype: boolean = false;
iswpsgroup: boolean = false;
isbank: boolean = false;
isbankbranch: boolean = false;


isdepartment: boolean = false;
isdesignation: boolean = false;
isemptype: boolean = false;
isgrade: boolean = false;
islocation: boolean = false;
isrelievetype: boolean = false;
issponser: boolean = false;
iscontracttype: boolean = false;
iscategory: boolean = false;


isgender: boolean = false;
ismaritialstatus: boolean = false;
isrelationship: boolean = false;
isreligion: boolean = false;
issalution: boolean = false;
isemployee: boolean = false;

isleavetype: boolean = false;
isovertimetype: boolean = false;
isholidays: boolean = false;
isleavepolicy: boolean = false;

isassettype: boolean = false;
isasset: boolean = false;
isincidenttype: boolean = false;
ismemotype: boolean = false;
isskills: boolean = false;
isaccomtype: boolean = false;
isstatus: boolean = false;
ishiresource: boolean = false;
isalerttype: boolean = false;

iscompany: boolean = false;
isbranch: boolean = false;
isuserrole: boolean = false;
isuser: boolean = false;
isdoctype: boolean = false;
isscheduletemplate: boolean = false;
isrequesttype:boolean = false;
isinsurancetype:boolean = false;
isinsurancecompany:boolean = false;
isreason:boolean = false;

menuColl: any = [];

  filtermenu: string = "";
  isprofessionaltax: boolean=false;
  settingsColl: any = [];


  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private productFindService: NgbModal, private datePipe: DatePipe,
    private confirmationDialogService: ConfirmationDialogService) {
      this.route.queryParams.subscribe(params => {
        if (params.menu !== undefined) {
          this.filtermenu = params.menu
        }        
      })        
    this.fnServiceChanges();
    
  }
  fnServiceChanges() {
    this.userrolerightsColl = this.loginService.userrolerightsColl;
    this.loginService.serviceloginChange.subscribe((value) => {
      this.userView = value
      if (this.userView.userBO) {
        this.userBO = this.userView.userBO
      }
    
      this.fnCheckMenu();

    });
  }


  ngOnInit() {
    if (this.loginService.fnCheckCompany()) {  

      if (this.userView.userBO) {
        this.userBO = this.userView.userBO
      }
      
      this.fnCheckMenu();

      this.fngetSettings();     
    }
    else{
      this.loginService.fnGetUserRoleList();
    } 
   

  }

  fngetSettings() {
    var data = {
      'settingsid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getSettings(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.settingsColl = res.json().result[1];
            for (let row of this.settingsColl) {

              if (row.settingsname === 'ENABLE PROFESSIONAL TAX' && row.settingsvalue === '1') {

                this.isprofessionaltax = true;

              }
            }
          }
          else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

 
  fnCheckMenu() {
    if (this.loginService.fnCheckUserRoleAll('Allowance')) {
      this.isallowance = true;
    }
    if (this.loginService.fnCheckUserRoleAll('BonusType')) {
      this.isbonustype = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Deduction')) {
      this.isdeduction = true;
    }
     if (this.loginService.fnCheckUserRoleAll('Expensetype')) {
      this.isexpensetype = true;
    }
     if (this.loginService.fnCheckUserRoleAll('ExpensePolicy')) {
      this.isexpensepolicy = true;
    }
    if (this.loginService.fnCheckUserRoleAll('LoanType')) {
      this.isloantype = true;
    }
    if (this.loginService.fnCheckUserRoleAll('PayMode')) {
      this.ispaymode = true;
    }
    if (this.loginService.fnCheckUserRoleAll('PayType')) {
      this.ispaytype = true;
    }
    if (this.loginService.fnCheckUserRoleAll('TransPaymode')) {
      this.istranspaymode = true;
    }
    if (this.loginService.fnCheckUserRoleAll('FineType')) {
      this.isfinetype = true;
    }
    if (this.loginService.fnCheckUserRoleAll('PayrollGroup')) {
      this.ispayrollgrp = true;
    }
    if (this.loginService.fnCheckUserRoleAll('ReimburseType')) {
      this.isreimbursetype = true;
    }
    if (this.loginService.fnCheckUserRoleAll('WpsGroup')) {
      this.iswpsgroup = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Bank')) {
      this.isbank = true;
    }
    if (this.loginService.fnCheckUserRoleAll('BankBranch')) {
      this.isbankbranch = true;
    }


    if (this.loginService.fnCheckUserRoleAll('Department')) {
      this.isdepartment = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Designation')) {
      this.isdesignation = true;
    }
    if (this.loginService.fnCheckUserRoleAll('EmpType')) {
      this.isemptype = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Grade')) {
      this.isgrade = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Location')) {
      this.islocation = true;
    }
    if (this.loginService.fnCheckUserRoleAll('RelieveType')) {
      this.isrelievetype = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Sponser')) {
      this.issponser = true;
    }
    if (this.loginService.fnCheckUserRoleAll('ContractType')) {
      this.iscontracttype = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Category')) {
      this.iscategory = true;
    }


    if (this.loginService.fnCheckUserRoleAll('Gender')) {
      this.isgender = true;
    }
    if (this.loginService.fnCheckUserRoleAll('MaritalStatus')) {
      this.ismaritialstatus = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Relationship')) {
      this.isrelationship = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Religion')) {
      this.isreligion = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Salution')) {
      this.issalution = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Employee')) {
      this.isemployee = true;
    }



    if (this.loginService.fnCheckUserRoleAll('LeaveType')) {
      this.isleavetype = true;
    }
    if (this.loginService.fnCheckUserRoleAll('OverTimeType')) {
      this.isovertimetype = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Holidays')) {
      this.isholidays = true;
    }
    if (this.loginService.fnCheckUserRoleAll('LeavePolicy')) {
      this.isleavepolicy = true;
    }


    if (this.loginService.fnCheckUserRoleAll('AssetType')) {
      this.isassettype = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Asset')) {
      this.isasset = true;
    }
    if (this.loginService.fnCheckUserRoleAll('IncidentType')) {
      this.isincidenttype = true;
    }
    if (this.loginService.fnCheckUserRoleAll('MemoType')) {
      this.ismemotype = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Skills')) {
      this.isskills = true;
    }
    if (this.loginService.fnCheckUserRoleAll('AccomType')) {
      this.isaccomtype = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Status')) {
      this.isstatus = true;
    }
    if (this.loginService.fnCheckUserRoleAll('HiResource')) {
      this.ishiresource = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Alerttype')) {
      this.isalerttype = true;
    }


    if (this.loginService.fnCheckUserRoleAll('Company')) {
      this.iscompany = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Branch')) {
      this.isbranch = true;
    }
    if (this.loginService.fnCheckUserRoleAll('UserRole')) {
      this.isuserrole = true;
    }
    if (this.loginService.fnCheckUserRoleAll('User')) {
      this.isuser = true;
    }
    if (this.loginService.fnCheckUserRoleAll('DocType')) {
      this.isdoctype = true;
    }
    if (this.loginService.fnCheckUserRoleAll('ScheduleTemplate')) {
      this.isscheduletemplate = true;
    }
    if (this.loginService.fnCheckUserRoleAll('RequestType')) {
      this.isrequesttype = true;
    }
    if (this.loginService.fnCheckUserRoleAll('InsuranceType')) {
      this.isinsurancetype = true;
    }
    if (this.loginService.fnCheckUserRoleAll('InsuranceCompany')) {
      this.isinsurancecompany = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Reason')) {
      this.isreason = true;
    }
  }





  fnMenuClick(form) {
    this.router.navigate([form]).then(() => {
           
     // document.getElementById('compact_submenuSidebar').classList.value = "submenu-sidebar";
      
    });
      
  }


  fnGenerateMenu() {
    this.menuColl.push({group:'',})
  }

}


